import React, { useEffect, useMemo } from 'react'
import { TFinishLine } from '../../shared/types/finishLine.type'
import { TCheckPoint } from '../../shared/types/checkPoint.type'
import { LatLng } from 'use-places-autocomplete'

type MapImageProps = {
  link?: string,
}


function MapImage({ link }: MapImageProps) {


  return (
    <img
      style={{ borderRadius: 7, width: "100%" }}
      src={link || 'https://placehold.jp/270x250.png'}
      alt=""
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = "https://placehold.jp/270x250.png";
      }}
    />
  );
}

export default MapImage;